import { create } from 'zustand'

const useProvidersStore = create(set => ({
  providers: [],
  setProviders: providers => set({ providers }),
  addProvider: provider =>
    set(state => ({
      providers: [provider, ...state.providers]
    })),
  removeProvider: providerId =>
    set(state => ({
      providers: state.providers.filter(provider => provider.id !== providerId)
    }))
}))

export default useProvidersStore
